import * as Yup from "yup";

// Validation schema for the Community Project modal (create / edit).
// Messages are pulled from the page-community-settings namespace via `t`.
const projectSchema = (t) =>
  Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(t("manage_community_projects.modal.validation.name_required")),
    type: Yup.string().required(
      t("manage_community_projects.modal.validation.type_required"),
    ),
    description: Yup.string(),
    terms: Yup.string(),
    fundingGoal: Yup.number()
      .typeError(
        t("manage_community_projects.modal.validation.funding_goal_required"),
      )
      .required(
        t("manage_community_projects.modal.validation.funding_goal_required"),
      )
      .moreThan(
        0,
        t("manage_community_projects.modal.validation.funding_goal_positive"),
      ),
    mainImage: Yup.string().required(
      t("manage_community_projects.modal.validation.main_image_required"),
    ),
  });

export default projectSchema;
